package com.schoolconnect.app.feature.support

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowForward
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Refresh
import androidx.compose.material.icons.filled.Search
import androidx.compose.material.icons.filled.Send
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.foundation.rememberScrollState
import androidx.compose.runtime.setValue
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppButton
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppInfoBg
import com.schoolconnect.app.designsystem.AppSecondaryBackground
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppCard
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppDialogBody
import com.schoolconnect.app.designsystem.AppDialogDefaultColors
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogDivider
import com.schoolconnect.app.designsystem.AppDialogFieldColumn
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogInputSize
import com.schoolconnect.app.designsystem.AppDialogLabelSize
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogSectionLabel
import com.schoolconnect.app.designsystem.AppDialogSize
import com.schoolconnect.app.designsystem.AppDialogTextField
import com.schoolconnect.app.designsystem.AppDialogDatePickerDialog
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.designsystem.AppOutlinedTextField
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.AppText
import com.schoolconnect.app.designsystem.AppWarning
import com.schoolconnect.app.designsystem.AppWarningSoft
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.designsystem.AppLabeledDropdownField
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.ShellPageHeader
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListPrimaryActionButton
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListSummaryCard
import com.schoolconnect.app.designsystem.list.DesktopAwareLazyColumn
import com.schoolconnect.app.designsystem.list.AdminListSummaryCardsShimmer
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminStatusChip
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.feature.common.pageFooterText
import com.schoolconnect.app.feature.common.pageWindow
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.arrow_right
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.cloud_upload
import ischoolconnect.sharedui.generated.resources.document
import ischoolconnect.sharedui.generated.resources.download
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.plus
import ischoolconnect.sharedui.generated.resources.refresh_cw
import org.jetbrains.compose.resources.painterResource
import io.github.vinceglb.filekit.compose.rememberFilePickerLauncher
import io.github.vinceglb.filekit.core.PickerType
import io.github.vinceglb.filekit.core.PlatformFile
import io.ktor.http.ContentType
import com.schoolconnect.app.util.decodeImageBitmap
import com.schoolconnect.app.downloadFile
import com.schoolconnect.app.repository.files.FileUploadRepository
import com.schoolconnect.app.repository.files.appendMimeTypeExtension
import com.schoolconnect.app.feature.support.SupportTicketMessageUi
import kotlinx.coroutines.launch
import kotlinx.coroutines.delay

private val SupportBackground = AppBackground
private val SupportBorder = AppBorder
private val SupportBlue = AppPrimary
private val SupportBlueSoft = AppPrimarySoft
private val SupportOrange = AppWarning
private val SupportOrangeSoft = AppWarningSoft
private val SupportGreen = AppSuccess
private val SupportGreenSoft = AppSuccessSoft
private val SupportMuted = AppMuted
private val SupportCardShape = RoundedCornerShape(10.dp)

private fun displaySupportStatus(value: String): String = when (value.trim().uppercase()) {
    "IN_PROGRESS" -> "In Progress"
    "OPEN" -> "Open"
    "RESOLVED" -> "Resolved"
    "CLOSED" -> "Closed"
    else -> value.ifBlank { "Unknown" }
}

private fun displaySupportRole(value: String): String {
    val normalized = value.trim().replace('_', ' ').replace('-', ' ')
    if (normalized.isBlank()) return "—"
    return normalized
        .lowercase()
        .split(Regex("\\s+"))
        .filter { it.isNotBlank() }
        .joinToString(" ") { part ->
            part.replaceFirstChar { char -> if (char.isLowerCase()) char.titlecase() else char.toString() }
        }
}

private fun formatSupportDate(value: String): String {
    val parts = value.trim().substringBefore("T").split("-")
    if (parts.size != 3) return value
    val months = listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")
    val month = parts[1].toIntOrNull()?.let { months.getOrNull(it - 1) } ?: return value
    return "${parts[2].take(2)} $month ${parts[0]}"
}

private fun supportAttachmentContentType(fileName: String): ContentType = when (fileName.substringAfterLast('.', "").lowercase()) {
    "pdf" -> ContentType.Application.Pdf
    "jpg", "jpeg" -> ContentType.Image.JPEG
    "png" -> ContentType.Image.PNG
    "doc" -> ContentType.parse("application/msword")
    "docx" -> ContentType.parse("application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    "xls" -> ContentType.parse("application/vnd.ms-excel")
    "xlsx" -> ContentType.parse("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
    else -> ContentType.Application.OctetStream
}

private enum class SupportView { DASHBOARD, TICKETS }
private enum class TicketSortField { ID, SUBJECT, RAISED_ON, UPDATED_ON, STATUS }

private fun TicketSortField.apiValue(): String = when (this) {
    TicketSortField.ID -> "ticket_id"
    TicketSortField.SUBJECT -> "subject"
    TicketSortField.RAISED_ON -> "created_at"
    TicketSortField.UPDATED_ON -> "updated_at"
    TicketSortField.STATUS -> "status"
}

private fun ticketSortFieldFromApiValue(value: String): TicketSortField = when (value) {
    "ticket_id" -> TicketSortField.ID
    "subject" -> TicketSortField.SUBJECT
    "created_at" -> TicketSortField.RAISED_ON
    "status" -> TicketSortField.STATUS
    else -> TicketSortField.UPDATED_ON
}

private data class Ticket(
    val id: String,
    val backendId: String,
    val subject: String,
    val raisedOn: String,
    val updatedOn: String,
    val status: String,
    val detail: String,
    val conversation: List<Pair<String, String>>
)

@Composable
internal fun SupportCenterScreen(
    schoolLabel: String,
    roleCode: String,
    roleLabel: String,
    onChangeRole: () -> Unit,
    onLogout: () -> Unit,
    onOpenDocumentLibrary: () -> Unit
) {
    val viewModel = remember { SupportTicketsViewModel() }
    val apiState by viewModel.uiState.collectAsState()
    var view by remember { mutableStateOf(SupportView.DASHBOARD) }
    var tickets by remember { mutableStateOf(emptyList<Ticket>()) }
    var dialog by remember { mutableStateOf<Ticket?>(null) }
    var showRaiseDialog by remember { mutableStateOf(false) }
    var profileExpanded by remember { mutableStateOf(false) }

    LaunchedEffect(apiState.tickets) {
        tickets = apiState.tickets.map { item ->
            Ticket(
                id = item.id,
                backendId = item.backendId,
                subject = item.subject,
                raisedOn = formatSupportDate(item.raisedOn),
                updatedOn = formatSupportDate(item.updatedOn),
                status = displaySupportStatus(item.status),
                detail = item.subject,
                conversation = emptyList()
            )
        }
    }
    DisposableEffect(viewModel) { onDispose { viewModel.clear() } }
    LaunchedEffect(apiState.saveGeneration) {
        if (apiState.saveGeneration > 0) {
            // Compose JS can finish the submit button click-sound callback
            // after the mutation succeeds. Keep the dialog attached briefly so
            // success navigation does not detach its modifier too early.
            delay(750)
            showRaiseDialog = false
            view = SupportView.TICKETS
        }
    }

    val headerActions: @Composable RowScope.() -> Unit = {
        ShellTopRightActions(
            roleLabel = roleLabel,
            roleSubtitle = shellRoleSubtitle(roleCode),
            initials = shellAvatarInitials(roleLabel),
            expanded = profileExpanded,
            onExpandedChange = { profileExpanded = it },
            onChangeRole = onChangeRole,
            onLogout = onLogout
        )
    }

    BoxWithConstraints(
        modifier = Modifier.fillMaxSize().background(SupportBackground)
    ) {
        val compact = maxWidth < 900.dp
        Column(Modifier.fillMaxSize()) {
            val toolbarTitle = if (view == SupportView.TICKETS) "My Support Tickets" else "Support Center"
            val toolbarSubtitle = if (view == SupportView.TICKETS) "View and track the support tickets raised by you." else "Get help, find guides, and manage your support tickets."
            ShellPageHeader(
                title = toolbarTitle,
                subtitle = toolbarSubtitle,
                titleColor = AppNavy,
                subtitleColor = SupportMuted,
                modifier = Modifier.padding(horizontal = 24.dp, vertical = 14.dp),
                headerActions = headerActions
            )
            HorizontalDivider(color = SupportBorder)
            if (view == SupportView.DASHBOARD) {
                DashboardContent(compact, schoolLabel, apiState, onOpenTickets = { view = SupportView.TICKETS }, onRaise = { showRaiseDialog = true }, onOpenDocumentLibrary = onOpenDocumentLibrary)
            } else {
                TicketListContent(compact, apiState, isLoading = apiState.isLoading, onBack = { view = SupportView.DASHBOARD }, onViewTicket = { ticket -> dialog = ticket; viewModel.openTicket(ticket.backendId) }, onSortChanged = viewModel::sortChanged, onSearchChanged = viewModel::searchChanged, onStatusChanged = viewModel::statusChanged, onPeriodChanged = viewModel::periodChanged, onCustomPeriodChanged = viewModel::customPeriodChanged, onClearFilters = viewModel::filtersCleared, onPageChanged = viewModel::pageChanged, onPageSizeChanged = viewModel::pageSizeChanged, onRaise = { showRaiseDialog = true })
            }
        }
    }

    dialog?.let { ticket ->
        TicketDialog(
            ticket = ticket,
            detail = apiState.selectedTicket,
            isLoading = apiState.isDetailLoading,
            errorMessage = apiState.detailErrorMessage,
            isReplying = apiState.isReplying,
            replyErrorMessage = apiState.replyErrorMessage,
            replyGeneration = apiState.replyGeneration,
            onDismiss = { if (!apiState.isReplying) dialog = null },
            onRetry = { viewModel.openTicket(ticket.backendId) },
            onReply = { reply, attachment -> viewModel.replyToTicket(ticket.backendId, reply, attachment) }
        )
    }
    if (showRaiseDialog) {
        RaiseTicketDialog(
            isSaving = apiState.isSaving,
            errorMessage = apiState.saveErrorMessage,
            onDismiss = { if (!apiState.isSaving) showRaiseDialog = false },
            onSubmit = { subject, description, attachment -> viewModel.createTicket(subject, description, attachment) }
        )
    }
}

@Composable
private fun DashboardContent(compact: Boolean, schoolLabel: String, apiState: SupportTicketsUiState, onOpenTickets: () -> Unit, onRaise: () -> Unit, onOpenDocumentLibrary: () -> Unit) {
    var helpQuery by remember { mutableStateOf("") }
    val guides = listOf(
        Triple("Getting Started", "Learn the basics and set up your account quickly.", Icons.Default.Info),
        Triple("Attendance", "Understand attendance tracking and reports.", Icons.Default.Person),
        Triple("Homework", "Manage assignments, submissions and grading.", Icons.Default.Info),
        Triple("Notices", "Learn how notices and announcements work.", Icons.Default.Notifications),
        Triple("Exams & Results", "View exam schedules, results and reports.", Icons.Default.Info),
        Triple("Parent Notes", "Add and manage notes for students.", Icons.Default.Info)
    )
    val columns = if (compact) 1 else 3
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .widthIn(max = 1240.dp)
            .verticalScroll(rememberScrollState())
            .padding(horizontal = 24.dp, vertical = 20.dp),
        verticalArrangement = Arrangement.spacedBy(18.dp)
    ) {
        AppCard(modifier = Modifier.fillMaxWidth().border(1.dp, SupportBorder, SupportCardShape), containerColor = Color.White) {
            Column(Modifier.padding(18.dp), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                Text("Help & Guides", color = AppNavy, fontSize = 16.sp, fontWeight = FontWeight.SemiBold)
                Text("Find answers to common questions and learn how to use iConnect.School.", color = AppMuted, fontSize = 14.sp, fontWeight = FontWeight.Normal)
                AdminListSearchField(helpQuery, { helpQuery = it }, "Search help topics", modifier = Modifier.fillMaxWidth(), width = if (compact) 320.dp else 760.dp)
                if (columns == 1) {
                    guides.forEach { (title, description, icon) -> GuideCard(title, description, icon, Modifier.fillMaxWidth()) }
                } else {
                    guides.chunked(columns).forEach { row -> Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) { row.forEach { (title, description, icon) -> GuideCard(title, description, icon, Modifier.weight(1f)) }; repeat(columns - row.size) { Spacer(Modifier.weight(1f)) } } }
                }
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
                    AdminListPrimaryActionButton("View All Help Documents", painterResource(Res.drawable.arrow_right), onOpenDocumentLibrary)
                }
            }
        }
        AppCard(modifier = Modifier.fillMaxWidth().border(1.dp, SupportBorder, SupportCardShape), containerColor = Color.White) {
            Column(Modifier.padding(18.dp), verticalArrangement = Arrangement.spacedBy(14.dp)) {
                Text("Support Tickets", color = AppNavy, fontSize = 16.sp, fontWeight = FontWeight.SemiBold)
                Text("Unable to find an answer? Raise a support ticket and our team will assist you.", color = AppMuted, fontSize = 14.sp, fontWeight = FontWeight.Normal)
                if (apiState.isLoading || apiState.isStatisticsLoading) {
                    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                        AdminListSummaryCardsShimmer(cardCount = 3)
                    }
                } else {
                    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                        AdminListSummaryCard("Open", apiState.statistics.open.toString(), "Needs attention", painterResource(Res.drawable.document), SupportBlue, SupportBlueSoft, AppMuted, modifier = Modifier.weight(1f))
                        AdminListSummaryCard("In Progress", apiState.statistics.inProgress.toString(), "Being reviewed", painterResource(Res.drawable.refresh_cw), SupportOrange, SupportOrangeSoft, AppMuted, modifier = Modifier.weight(1f))
                        AdminListSummaryCard("Resolved", apiState.statistics.resolved.toString(), "Successfully closed", painterResource(Res.drawable.circle_check), SupportGreen, SupportGreenSoft, AppMuted, modifier = Modifier.weight(1f))
                }
                    if (apiState.errorMessage.isNotBlank()) {
                        AppDialogErrorMessage(apiState.errorMessage)
                    }
                }
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End, verticalAlignment = Alignment.CenterVertically) {
                    AppOutlinedButton(onClick = onOpenTickets, modifier = Modifier.height(40.dp), colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary), border = BorderStroke(1.dp, AppBorder), shape = RoundedCornerShape(8.dp), contentPadding = PaddingValues(horizontal = 16.dp)) { Text("My Tickets", color = AppPrimary, fontSize = 14.sp, fontWeight = FontWeight.SemiBold) }
                    Spacer(Modifier.width(12.dp))
                    AdminListPrimaryActionButton("Raise Ticket", painterResource(Res.drawable.plus), onRaise)
                }
            }
        }
        AppText("${schoolLabel.ifBlank { "Your school" }} • Support is available for account, data and workflow issues.", color = SupportMuted, style = MaterialTheme.typography.bodySmall)
    }
}


@Composable
private fun GuideCard(title: String, description: String, icon: androidx.compose.ui.graphics.vector.ImageVector, modifier: Modifier) {
    AppCard(modifier = modifier.border(1.dp, SupportBorder, SupportCardShape), containerColor = Color.White) {
        Row(Modifier.padding(14.dp).heightIn(min = 70.dp), horizontalArrangement = Arrangement.spacedBy(14.dp), verticalAlignment = Alignment.CenterVertically) {
            Surface(shape = RoundedCornerShape(10.dp), color = SupportBlueSoft) { Icon(icon, null, tint = SupportBlue, modifier = Modifier.padding(10.dp).size(20.dp)) }
            Column(verticalArrangement = Arrangement.spacedBy(3.dp)) { AppText(title, color = AppNavy, fontWeight = FontWeight.Bold); Text(description, color = AppMuted, style = MaterialTheme.typography.bodySmall, maxLines = 2, overflow = TextOverflow.Ellipsis) }
        }
    }
}

@Composable
private fun TicketListContent(compact: Boolean, apiState: SupportTicketsUiState, isLoading: Boolean, onBack: () -> Unit, onViewTicket: (Ticket) -> Unit, onSortChanged: (String, Boolean) -> Unit, onSearchChanged: (String) -> Unit, onStatusChanged: (String) -> Unit, onPeriodChanged: (String) -> Unit, onCustomPeriodChanged: (String, String) -> Unit, onClearFilters: () -> Unit, onPageChanged: (Int) -> Unit, onPageSizeChanged: (Int) -> Unit, onRaise: () -> Unit) {
    var rowsMenu by remember { mutableStateOf(false) }
    var customRangeVisible by remember { mutableStateOf(false) }
    val sortField = ticketSortFieldFromApiValue(apiState.sortBy)
    val tickets = apiState.tickets.map { item ->
        Ticket(item.id, item.backendId, item.subject, formatSupportDate(item.raisedOn), formatSupportDate(item.updatedOn), displaySupportStatus(item.status), item.subject, emptyList())
    }
    val sortAscending = apiState.sortAscending
    fun toggleSort(field: TicketSortField) {
        val nextAscending = if (sortField == field) !apiState.sortAscending else true
        onSortChanged(field.apiValue(), nextAscending)
    }
    val window = pageWindow(apiState.pageIndex, apiState.pageSize, apiState.totalCount)
    AdminListPageScaffold(
        title = "My Support Tickets",
        subtitle = "View and track the support tickets raised by you.",
        showTitleBlock = false,
        backgroundColor = AppBackground,
        titleColor = AppNavy,
        subtitleColor = AppMuted,
        maxContentWidth = 1400.dp,
        summaryCards = {
            if (isLoading || apiState.isStatisticsLoading) {
                AdminListSummaryCardsShimmer(cardCount = 3)
            } else {
                AdminListSummaryCard("Open", apiState.statistics.open.toString(), "Needs attention", painterResource(Res.drawable.document), AppPrimary, AppPrimarySoft, AppMuted, modifier = Modifier.weight(1f))
                AdminListSummaryCard("In Progress", apiState.statistics.inProgress.toString(), "Being reviewed", painterResource(Res.drawable.refresh_cw), AppWarning, AppWarningSoft, AppMuted, modifier = Modifier.weight(1f))
                AdminListSummaryCard("Resolved", apiState.statistics.resolved.toString(), "Successfully closed", painterResource(Res.drawable.circle_check), AppSuccess, AppSuccessSoft, AppMuted, modifier = Modifier.weight(1f))
            }
        },
        toolbar = {
            AppCard(
                modifier = Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(10.dp)),
                containerColor = Color.White
            ) {
                Row(
                    Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 14.dp),
                    horizontalArrangement = Arrangement.spacedBy(14.dp),
                    verticalAlignment = Alignment.Bottom
                ) {
                    Column(verticalArrangement = Arrangement.spacedBy(7.dp), modifier = Modifier.weight(1.4f)) {
                        Text("Search by Ticket ID or Subject", style = MaterialTheme.typography.labelLarge, color = AppNavy, fontWeight = FontWeight.Bold)
                        AdminListSearchField(apiState.query, onSearchChanged, "Search...", width = 430.dp, height = 44.dp, modifier = Modifier.fillMaxWidth())
                    }
                    Column(verticalArrangement = Arrangement.spacedBy(7.dp), modifier = Modifier.weight(1f)) {
                        Text("Status", style = MaterialTheme.typography.labelLarge, color = AppNavy, fontWeight = FontWeight.Bold)
                        SupportFilterDropdown(apiState.status, listOf("All Statuses", "Open", "In Progress", "Resolved", "Closed"), Modifier.fillMaxWidth(), onStatusChanged)
                    }
                    Column(verticalArrangement = Arrangement.spacedBy(7.dp), modifier = Modifier.weight(1f)) {
                        Text("Period", style = MaterialTheme.typography.labelLarge, color = AppNavy, fontWeight = FontWeight.Bold)
                        SupportFilterDropdown(
                            apiState.periodRange,
                            listOf("All Time", "Last 30 Days", "Last 90 Days", "Custom Range"),
                            Modifier.fillMaxWidth(),
                            onSelected = { value ->
                                if (value == "Custom Range") customRangeVisible = true else onPeriodChanged(value)
                            }
                        )
                    }
                    AppOutlinedButton(
                        onClick = onClearFilters,
                        modifier = Modifier.width(116.dp).height(44.dp),
                        contentPadding = PaddingValues(horizontal = 12.dp),
                        colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary),
                        shape = RoundedCornerShape(8.dp)
                    ) {
                        Icon(painterResource(Res.drawable.refresh_cw), contentDescription = null, modifier = Modifier.size(17.dp), tint = AppPrimary)
                        Spacer(Modifier.width(6.dp))
                        Text("Clear", color = AppPrimary, fontWeight = FontWeight.Bold)
                    }
                }
            }
        },
        table = { modifier ->
            AdminListTableCard(
                modifier = modifier,
                minContentWidth = 980.dp,
                header = { AdminListSortHeaderRow(listOf(
                    AdminListSortColumn("Ticket ID", 1f, sortField == TicketSortField.ID, sortAscending, onClick = { toggleSort(TicketSortField.ID) }),
                    AdminListSortColumn("Subject", 2.2f, sortField == TicketSortField.SUBJECT, sortAscending, onClick = { toggleSort(TicketSortField.SUBJECT) }),
                    AdminListSortColumn("Raised On", 1f, sortField == TicketSortField.RAISED_ON, sortAscending, onClick = { toggleSort(TicketSortField.RAISED_ON) }),
                    AdminListSortColumn("Last Updated", 1.1f, sortField == TicketSortField.UPDATED_ON, sortAscending, onClick = { toggleSort(TicketSortField.UPDATED_ON) }),
                    AdminListSortColumn("Status", 1f, sortField == TicketSortField.STATUS, sortAscending, onClick = { toggleSort(TicketSortField.STATUS) })
                ), actionsLabel = "Actions", actionsWeight = 0.55f) },
                body = {
                    if (isLoading) {
                        AdminListTableShimmer(
                            columns = listOf(
                                AdminListHeaderColumn("Ticket ID", 1f),
                                AdminListHeaderColumn("Subject", 2.2f),
                                AdminListHeaderColumn("Raised On", 1f),
                                AdminListHeaderColumn("Last Updated", 1.1f),
                                AdminListHeaderColumn("Status", 1f),
                                AdminListHeaderColumn("Actions", 0.55f)
                            ),
                            modifier = Modifier.fillMaxWidth(),
                            rowCount = 6,
                            horizontalPadding = 24.dp
                        )
                    } else if (tickets.isEmpty()) {
                        Box(Modifier.fillMaxWidth().heightIn(min = 220.dp), contentAlignment = Alignment.Center) { Column(horizontalAlignment = Alignment.CenterHorizontally, verticalArrangement = Arrangement.spacedBy(6.dp)) { AppText("No tickets match your search", color = AppNavy, fontWeight = FontWeight.Bold); AppText("Try a different Ticket ID, subject, or status.", color = AppMuted) } }
                    } else {
                        AdminListTableBody(items = tickets, key = { it.backendId.ifBlank { it.id } }, modifier = Modifier.fillMaxWidth()) { ticket ->
                            Column(Modifier.fillMaxWidth()) {
                                Row(Modifier.fillMaxWidth().onViewDoubleClick { onViewTicket(ticket) }.padding(horizontal = 24.dp, vertical = 15.dp), verticalAlignment = Alignment.CenterVertically) {
                                    AdminListTableBodyText(ticket.id, Modifier.weight(1f), color = AppPrimary, fontWeight = FontWeight.Bold)
                                    AdminListTableBodyText(ticket.subject, Modifier.weight(2.2f), fontWeight = FontWeight.Medium)
                                    AdminListTableBodyText(ticket.raisedOn, Modifier.weight(1f))
                                    AdminListTableBodyText(ticket.updatedOn, Modifier.weight(1.1f))
                                    Box(Modifier.weight(1f), contentAlignment = Alignment.CenterStart) {
                                        StatusChip(ticket.status)
                                    }
                                    Box(Modifier.weight(0.55f), contentAlignment = Alignment.Center) { Icon(painterResource(Res.drawable.eye), "View ${ticket.id}", tint = AppNavy, modifier = Modifier.size(16.dp).clickable { onViewTicket(ticket) }) }
                                }
                                if (ticket.id != tickets.lastOrNull()?.id) {
                                    HorizontalDivider(modifier = Modifier.fillMaxWidth(), color = AppBorder)
                                }
                            }
                        }
                    }
                },
                footer = { AdminListFooter(pageFooterText(window, "tickets"), window.pageIndex, window.pageCount, onPageChanged, apiState.pageSize, rowsMenu, { rowsMenu = !rowsMenu }, { rowsMenu = false }, onPageSizeChanged) }
            )
        },
        bottomAction = {
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                AppOutlinedButton(
                    onClick = onBack,
                    modifier = Modifier.height(40.dp),
                    colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary),
                    border = BorderStroke(1.dp, AppBorder),
                    contentPadding = PaddingValues(horizontal = 16.dp),
                    shape = RoundedCornerShape(8.dp)
                ) { Text("Back to Support Center", color = AppPrimary, fontSize = 14.sp, fontWeight = FontWeight.SemiBold) }
                AdminListPrimaryActionButton(
                    label = "Raise Ticket",
                    icon = painterResource(Res.drawable.plus),
                    onClick = onRaise
                )
            }
        }
    )

    if (customRangeVisible) {
        AppDialogDatePickerDialog(
            value = apiState.periodFrom,
            onDismiss = { customRangeVisible = false },
            onDateSelected = {},
            colors = AppDialogDefaultColors,
            dateRangeSelection = true,
            dateRangeStartValue = apiState.periodFrom,
            dateRangeEndValue = apiState.periodTo,
            onDateRangeSelected = { from, to ->
                customRangeVisible = false
                onCustomPeriodChanged(from, to)
            }
        )
    }
}

@Composable private fun StatusChip(status: String) { val color = when (status) { "Open" -> AppPrimary; "In Progress" -> AppWarning; "Resolved" -> AppSuccess; else -> AppMuted }; val background = when (status) { "Open" -> AppPrimarySoft; "In Progress" -> AppWarningSoft; "Resolved" -> AppSuccessSoft; else -> AppSecondaryBackground }; AdminStatusChip(status, color, background, dotColor = color) }
@Composable private fun SupportFilterDropdown(value: String, options: List<String>, modifier: Modifier, onSelected: (String) -> Unit) =
    AppLabeledDropdownField("", value, options, onSelected, modifier, includeAllOption = false)

@Composable
private fun RaiseTicketDialog(
    isSaving: Boolean,
    errorMessage: String,
    onDismiss: () -> Unit,
    onSubmit: (String, String, SupportTicketAttachment?) -> Unit
) {
    var subject by remember { mutableStateOf("") }; var description by remember { mutableStateOf("") }
    var submitStarted by remember { mutableStateOf(false) }
    var selectedFile by remember { mutableStateOf<PlatformFile?>(null) }
    var attachmentPreviewBytes by remember { mutableStateOf<ByteArray?>(null) }
    var attachmentError by remember { mutableStateOf("") }
    val pickerScope = rememberCoroutineScope()
    val attachmentPicker = rememberFilePickerLauncher(
        type = PickerType.File(listOf("pdf", "doc", "docx", "xls", "xlsx", "jpg", "jpeg", "png")),
        title = "Select Support Attachment"
    ) { file ->
        selectedFile = file
        attachmentError = ""
        attachmentPreviewBytes = null
        file?.takeIf { isSupportImageFile(it.name) }?.let { selected ->
            pickerScope.launch { attachmentPreviewBytes = runCatching { selected.readBytes() }.getOrNull() }
        }
    }
    val canSubmit = subject.isNotBlank() && description.isNotBlank()
    LaunchedEffect(errorMessage) {
        if (errorMessage.isNotBlank()) submitStarted = false
    }
    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Standard,
        dialogWidthOverride = 680.dp,
        maxDialogHeight = 720.dp,
        isLoading = isSaving,
        loadingTitle = "Saving support ticket"
    ) {
        AppDialogHeader(
            title = "Raise Support Ticket",
            subtitle = "Describe the issue and our support team will assist you.",
            onClose = onDismiss,
            colors = AppDialogDefaultColors
        )
        AppDialogDivider()
        AppDialogBody(
            colors = AppDialogDefaultColors,
            horizontalPadding = 24.dp,
            verticalPadding = 22.dp,
            showVerticalScrollbar = true
        ) {
            if (errorMessage.isNotBlank()) AppDialogErrorMessage(errorMessage)
            AppDialogFieldColumn("Subject", required = true, colors = AppDialogDefaultColors) {
                AppDialogTextField(
                    value = subject,
                    onValueChange = { subject = it },
                    placeholder = "Enter a brief subject",
                    colors = AppDialogDefaultColors
                )
            }
            AppDialogFieldColumn("Description", required = true, colors = AppDialogDefaultColors) {
                AppDialogTextField(
                    value = description,
                    onValueChange = { description = it },
                    placeholder = "Describe the issue in detail",
                    colors = AppDialogDefaultColors,
                    singleLine = false,
                    fieldHeight = 128.dp
                )
            }
            SupportAttachmentField(
                selectedFile = selectedFile,
                previewBytes = attachmentPreviewBytes,
                onPick = { attachmentPicker.launch() },
                onRemove = { selectedFile = null; attachmentPreviewBytes = null; attachmentError = "" },
                errorMessage = attachmentError
            )
        }
        AppDialogDivider()
        AppDialogFooter(
            actions = listOf(
                AppDialogFooterAction("Cancel", onDismiss, AppDialogActionStyle.Secondary, width = 108.dp),
                AppDialogFooterAction(if (isSaving) "Saving…" else "Save", {
                    if (!submitStarted && !isSaving) {
                        submitStarted = true
                        if (selectedFile == null) {
                            onSubmit(subject.trim(), description.trim(), null)
                        } else {
                            pickerScope.launch {
                                runCatching { selectedFile!!.readBytes() }
                                    .onSuccess { bytes ->
                                        if (bytes.isEmpty()) {
                                            submitStarted = false
                                            attachmentError = "Unable to read ${selectedFile!!.name}."
                                        } else {
                                            onSubmit(subject.trim(), description.trim(), SupportTicketAttachment(selectedFile!!.name, bytes, supportAttachmentContentType(selectedFile!!.name)))
                                        }
                                    }
                                    .onFailure {
                                        submitStarted = false
                                        attachmentError = "Unable to read ${selectedFile!!.name}."
                                    }
                            }
                        }
                    }
                }, AppDialogActionStyle.Primary, enabled = canSubmit && !isSaving && !submitStarted, width = 108.dp)
            ),
            colors = AppDialogDefaultColors,
            equalWeightButtons = false
        )
    }
}

@Composable
private fun TicketDialog(
    ticket: Ticket,
    detail: SupportTicketDetailUi?,
    isLoading: Boolean,
    errorMessage: String,
    isReplying: Boolean,
    replyErrorMessage: String,
    replyGeneration: Int,
    onDismiss: () -> Unit,
    onRetry: () -> Unit,
    onReply: (String, SupportTicketAttachment?) -> Unit
) {
    var reply by remember { mutableStateOf("") }
    var selectedFile by remember { mutableStateOf<PlatformFile?>(null) }
    var attachmentPreviewBytes by remember { mutableStateOf<ByteArray?>(null) }
    var attachmentError by remember { mutableStateOf("") }
    val pickerScope = rememberCoroutineScope()
    val conversationListState = rememberLazyListState()
    val attachmentPicker = rememberFilePickerLauncher(
        type = PickerType.File(listOf("pdf", "doc", "docx", "xls", "xlsx", "jpg", "jpeg", "png")),
        title = "Select Reply Attachment"
    ) { file ->
        selectedFile = file
        attachmentError = ""
        attachmentPreviewBytes = null
        file?.takeIf { isSupportImageFile(it.name) }?.let { selected ->
            pickerScope.launch { attachmentPreviewBytes = runCatching { selected.readBytes() }.getOrNull() }
        }
    }
    LaunchedEffect(replyGeneration) {
        if (replyGeneration > 0) {
            reply = ""
            selectedFile = null
            attachmentPreviewBytes = null
            attachmentError = ""
        }
    }
    val shownTicket = detail ?: SupportTicketDetailUi(
        id = ticket.id,
        subject = ticket.subject,
        description = ticket.detail,
        raisedOn = ticket.raisedOn,
        updatedOn = ticket.updatedOn,
        status = ticket.status,
        conversation = ticket.conversation.map { (sender, message) -> SupportTicketMessageUi(sender, message) }
    )
    var isDescriptionExpanded by remember(shownTicket.id) { mutableStateOf(true) }
    var historyAttachments by remember(shownTicket.id, shownTicket.conversation) {
        mutableStateOf(emptyMap<String, SupportConversationAttachmentUi>())
    }
    var downloadingAttachmentId by remember(shownTicket.id) { mutableStateOf<String?>(null) }
    LaunchedEffect(shownTicket.id, shownTicket.conversation) {
        val refs = buildList {
            shownTicket.attachmentFileIds.forEachIndexed { index, id ->
                add(id to shownTicket.attachmentFileUrls.getOrNull(index).orEmpty())
            }
            shownTicket.conversation.forEach { message ->
                message.attachmentFileIds.forEachIndexed { index, id ->
                    add(id to message.attachmentFileUrls.getOrNull(index).orEmpty())
                }
            }
        }.filter { it.first.isNotBlank() || it.second.isNotBlank() }.distinctBy { it.first.ifBlank { it.second } }
        historyAttachments = refs.associate { (fileId, responseUrl) ->
            val resolvedFileId = fileId.ifBlank { responseUrl.substringBefore('?').substringAfterLast('/') }
            val metadata = resolvedFileId.takeIf { it.isNotBlank() }?.let { FileUploadRepository.getMetadata(it).getOrNull() }
            val mimeType = metadata?.detectedMimeType ?: metadata?.declaredMimeType ?: "application/octet-stream"
            val url = responseUrl.takeIf { it.startsWith("http://") || it.startsWith("https://") }
                ?: resolvedFileId.takeIf { it.isNotBlank() }?.let { FileUploadRepository.getDownloadUrl(it).getOrNull()?.url }
                ?: ""
            val previewBytes = if (mimeType.startsWith("image/", ignoreCase = true) && url.isNotBlank()) {
                FileUploadRepository.downloadBytes(url).getOrNull()
            } else null
            resolvedFileId to SupportConversationAttachmentUi(
                fileId = resolvedFileId,
                url = url,
                name = metadata?.originalFilename.orEmpty().ifBlank { "Attachment" },
                mimeType = mimeType,
                sizeLabel = metadata?.sizeBytes?.let(::formatSupportAttachmentSize) ?: "File",
                previewBytes = previewBytes
            )
        }
    }
    fun downloadHistoryAttachment(attachment: SupportConversationAttachmentUi) {
        if (attachment.url.isBlank()) return
        pickerScope.launch {
            downloadingAttachmentId = attachment.fileId
            try {
                FileUploadRepository.downloadBytes(attachment.url).onSuccess { bytes ->
                    downloadFile(appendMimeTypeExtension(attachment.name, attachment.mimeType), bytes, attachment.mimeType)
                }
            } finally {
                downloadingAttachmentId = null
            }
        }
    }
    LaunchedEffect(shownTicket.id, shownTicket.conversation) {
        if (shownTicket.conversation.isNotEmpty()) {
            conversationListState.animateScrollToItem(shownTicket.conversation.lastIndex)
        }
    }
    val canReply = shownTicket.status.equals("OPEN", true) || shownTicket.status.equals("IN_PROGRESS", true) || shownTicket.status == "Open" || shownTicket.status == "In Progress"
    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Wide,
        dialogWidthOverride = 760.dp,
        maxDialogHeight = 1000.dp,
        viewportFraction = 0.98f,
        fillDialogHeight = true,
        isLoading = isReplying,
        loadingTitle = "Sending reply"
    ) {
        AppDialogHeader(
            title = "View Ticket",
            subtitle = "View ticket details and conversation.",
            titleSuffix = ticket.id,
            titleSuffixSeparator = " ",
            titleSuffixFontSize = 16.sp,
            onClose = onDismiss,
            colors = AppDialogDefaultColors
        )
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f)
                .padding(horizontal = 24.dp, vertical = 18.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(28.dp)) {
                Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                    Text("Subject", color = AppNavy, fontSize = AppDialogLabelSize, fontWeight = FontWeight.SemiBold)
                    Text(shownTicket.subject, color = AppNavy, fontSize = AppDialogInputSize, fontWeight = FontWeight.Normal)
                }
                Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                    Text("Status", color = AppNavy, fontSize = AppDialogLabelSize, fontWeight = FontWeight.SemiBold)
                    StatusChip(displaySupportStatus(shownTicket.status))
                }
            }
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(28.dp)) {
                TicketDialogValue("Raised On", formatSupportDate(shownTicket.raisedOn), Modifier.weight(1f))
                TicketDialogValue("Last Updated", formatSupportDate(shownTicket.updatedOn), Modifier.weight(1f))
            }
            if (shownTicket.description.isNotBlank() || shownTicket.attachmentFileIds.isNotEmpty() || shownTicket.attachmentFileUrls.isNotEmpty()) {
                Surface(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(8.dp),
                    color = AppSurface,
                    border = BorderStroke(1.dp, AppBorder)
                ) {
                    Column(Modifier.padding(10.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                        Row(
                            modifier = Modifier.fillMaxWidth().clickable { isDescriptionExpanded = !isDescriptionExpanded },
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            AppDialogSectionLabel("Description", colors = AppDialogDefaultColors, fontSize = 16.sp)
                            Icon(
                                imageVector = if (isDescriptionExpanded) Icons.Default.KeyboardArrowUp else Icons.Default.KeyboardArrowDown,
                                contentDescription = if (isDescriptionExpanded) "Collapse description" else "Expand description",
                                tint = AppMuted,
                                modifier = Modifier.size(20.dp)
                            )
                        }
                        if (isDescriptionExpanded) {
                            if (shownTicket.description.isNotBlank()) {
                                Text(shownTicket.description, color = AppNavy, fontSize = AppDialogInputSize, fontWeight = FontWeight.Normal)
                            }
                            val descriptionRefs = shownTicket.attachmentFileIds.mapIndexed { index, id ->
                                id to shownTicket.attachmentFileUrls.getOrNull(index).orEmpty()
                            }.ifEmpty { shownTicket.attachmentFileUrls.map { "" to it } }
                            descriptionRefs.filter { it.first.isNotBlank() || it.second.isNotBlank() }.forEach { (fileId, responseUrl) ->
                                val key = fileId.ifBlank { responseUrl.substringBefore('?').substringAfterLast('/') }
                                historyAttachments[key]?.let { attachment ->
                                    SupportConversationAttachmentRow(
                                        attachment = attachment,
                                        isDownloading = downloadingAttachmentId == attachment.fileId,
                                        onDownload = { downloadHistoryAttachment(attachment) }
                                    )
                                }
                            }
                        }
                    }
                }
            }
            AppDialogDivider()
            Surface(
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f),
                shape = RoundedCornerShape(8.dp),
                color = AppSurface,
                border = BorderStroke(1.dp, AppBorder)
            ) {
                Column(Modifier.fillMaxSize().padding(10.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                        AppDialogSectionLabel("Conversation", colors = AppDialogDefaultColors, fontSize = 16.sp)
                        Text("${shownTicket.conversation.size} ${if (shownTicket.conversation.size == 1) "message" else "messages"}", color = AppMuted, fontSize = 12.sp)
                    }
                    when {
                        isLoading -> AppText("Loading conversation…", color = AppMuted)
                        errorMessage.isNotBlank() -> {
                            AppDialogErrorMessage(errorMessage)
                            AppOutlinedButton(onClick = onRetry, modifier = Modifier.height(38.dp), border = BorderStroke(1.dp, AppBorder), contentPadding = PaddingValues(horizontal = 14.dp)) { Text("Retry") }
                        }
                    }
                    DesktopAwareLazyColumn(
                        modifier = Modifier.fillMaxWidth().weight(1f),
                        state = conversationListState,
                        contentPadding = PaddingValues(end = 12.dp),
                        verticalArrangement = Arrangement.spacedBy(10.dp)
                    ) {
                        itemsIndexed(shownTicket.conversation) { index, message ->
                            Surface(
                                modifier = Modifier.fillMaxWidth(),
                                color = if (message.sender == "You") Color.White else AppInfoBg,
                                shape = RoundedCornerShape(8.dp),
                                border = BorderStroke(1.dp, AppBorder)
                            ) {
                                Column(Modifier.padding(14.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                                    Text(message.sender, color = AppNavy, fontSize = AppDialogInputSize, fontWeight = FontWeight.SemiBold)
                                    if (message.message.isNotBlank()) Text(message.message, color = AppNavy, fontSize = AppDialogInputSize, fontWeight = FontWeight.Normal)
                                    supportAttachmentRefs(message).forEach { (fileId, responseUrl) ->
                                        val key = fileId.ifBlank { responseUrl.substringBefore('?').substringAfterLast('/') }
                                        historyAttachments[key]?.let { attachment ->
                                            SupportConversationAttachmentRow(
                                                attachment = attachment,
                                                isDownloading = downloadingAttachmentId == attachment.fileId,
                                                onDownload = { downloadHistoryAttachment(attachment) }
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (canReply && !isLoading && errorMessage.isBlank()) {
                Surface(Modifier.fillMaxWidth(), shape = RoundedCornerShape(8.dp), color = AppSurface, border = BorderStroke(1.dp, AppBorder)) {
                    Column(Modifier.padding(10.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                        AppDialogSectionLabel("Reply", colors = AppDialogDefaultColors, fontSize = 16.sp)
                        AppDialogTextField(reply, { reply = it }, "Write your reply", colors = AppDialogDefaultColors, singleLine = false, fieldHeight = 76.dp, maxLength = 2000)
                        SupportAttachmentField(
                            selectedFile = selectedFile,
                            previewBytes = attachmentPreviewBytes,
                            onPick = { attachmentPicker.launch() },
                            onRemove = { selectedFile = null; attachmentPreviewBytes = null; attachmentError = "" },
                            errorMessage = attachmentError
                        )
                        if (replyErrorMessage.isNotBlank()) AppDialogErrorMessage(replyErrorMessage)
                    }
                }
            } else {
                AppText("This ticket is read-only because it is closed.", color = AppMuted, style = MaterialTheme.typography.bodySmall)
            }
        }
        AppDialogDivider()
        AppDialogFooter(
            actions = buildList {
                add(AppDialogFooterAction("Close", onDismiss, AppDialogActionStyle.Secondary, width = 108.dp))
                if (canReply) add(AppDialogFooterAction("Send Reply", {
                    if (reply.isNotBlank() && !isReplying) {
                        if (selectedFile == null) onReply(reply.trim(), null)
                        else pickerScope.launch {
                            val file = selectedFile ?: return@launch
                            runCatching { file.readBytes() }
                                .onSuccess { bytes ->
                                    if (bytes.isEmpty()) attachmentError = "Unable to read ${file.name}."
                                    else onReply(reply.trim(), SupportTicketAttachment(file.name, bytes, supportAttachmentContentType(file.name)))
                                }
                                .onFailure { attachmentError = "Unable to read ${file.name}." }
                        }
                    }
                }, AppDialogActionStyle.Primary, enabled = reply.isNotBlank() && !isReplying, width = 140.dp))
            },
            colors = AppDialogDefaultColors,
            equalWeightButtons = false
        )
    }
}

@Composable
private fun SupportAttachmentField(
    selectedFile: PlatformFile?,
    previewBytes: ByteArray?,
    onPick: () -> Unit,
    onRemove: () -> Unit,
    errorMessage: String
) {
    AppDialogFieldColumn("Attachment", helperText = "Optional", colors = AppDialogDefaultColors) {
        Row(
            Modifier.fillMaxWidth()
                .border(1.dp, AppBorder, RoundedCornerShape(8.dp))
                .padding(10.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            AppOutlinedButton(
                onClick = onPick,
                modifier = Modifier.width(170.dp).height(44.dp),
                contentPadding = PaddingValues(horizontal = 12.dp),
                colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary),
                shape = RoundedCornerShape(8.dp)
            ) {
                Icon(painterResource(Res.drawable.cloud_upload), null, tint = AppPrimary, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(8.dp))
                Text("Upload Files", color = AppPrimary, fontWeight = FontWeight.SemiBold)
            }
            Spacer(Modifier.width(14.dp))
            Text(
                if (selectedFile == null) "No files selected" else "1 file selected",
                color = AppMuted,
                fontSize = 13.sp
            )
        }
        selectedFile?.let { file ->
            SupportAttachmentChip(file, previewBytes, Modifier.fillMaxWidth(), onRemove)
        }
        Text("Supported: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG (Max 10 MB)", color = AppMuted, fontSize = 12.sp)
        if (errorMessage.isNotBlank()) AppText(errorMessage, color = AppDanger, style = MaterialTheme.typography.bodySmall)
    }
}

@Composable
private fun SupportAttachmentChip(file: PlatformFile, previewBytes: ByteArray?, modifier: Modifier, onRemove: () -> Unit) {
    Row(
        modifier = modifier.height(72.dp).border(1.dp, AppBorder, RoundedCornerShape(8.dp)).padding(horizontal = 10.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        val preview = previewBytes?.let(::decodeImageBitmap)
        if (preview != null) {
            androidx.compose.foundation.Image(
                bitmap = preview,
                contentDescription = file.name,
                modifier = Modifier.size(52.dp),
                contentScale = ContentScale.Fit
            )
        } else {
            Box(Modifier.size(36.dp).background(Color(0xFFEAF8EF), RoundedCornerShape(6.dp)), contentAlignment = Alignment.Center) {
                Icon(painterResource(Res.drawable.document), null, tint = AppPrimary, modifier = Modifier.size(19.dp))
            }
        }
        Spacer(Modifier.width(8.dp))
        Column(Modifier.weight(1f)) {
            Text(file.name, color = AppNavy, fontSize = 12.sp, maxLines = 1, overflow = TextOverflow.Ellipsis)
            Text("${file.name.substringAfterLast('.', "FILE").uppercase()}  •  ${formatSupportAttachmentSize(file.getSize())}", color = AppMuted, fontSize = 11.sp)
        }
        Icon(painterResource(Res.drawable.close_x), "Remove ${file.name}", tint = AppNavy, modifier = Modifier.size(18.dp).clickable(onClick = onRemove))
    }
}

private data class SupportConversationAttachmentUi(
    val fileId: String,
    val url: String,
    val name: String,
    val mimeType: String,
    val sizeLabel: String,
    val previewBytes: ByteArray? = null
)

private fun supportAttachmentRefs(message: SupportTicketMessageUi): List<Pair<String, String>> =
    message.attachmentFileIds.mapIndexed { index, id -> id to message.attachmentFileUrls.getOrNull(index).orEmpty() }
        .ifEmpty { message.attachmentFileUrls.map { "" to it } }
        .filter { it.first.isNotBlank() || it.second.isNotBlank() }

@Composable
private fun SupportConversationAttachmentRow(
    attachment: SupportConversationAttachmentUi,
    isDownloading: Boolean,
    onDownload: () -> Unit
) {
    val image = remember(attachment.fileId, attachment.previewBytes) { attachment.previewBytes?.let(::decodeImageBitmap) }
    val kind = when {
        attachment.mimeType.startsWith("image/", ignoreCase = true) -> "Image"
        attachment.mimeType.contains("pdf", ignoreCase = true) -> "PDF"
        else -> attachment.name.substringAfterLast('.', "FILE").uppercase().ifBlank { "FILE" }
    }
    Row(
        Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(8.dp)).padding(8.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        if (image != null) {
            androidx.compose.foundation.Image(
                bitmap = image,
                contentDescription = attachment.name,
                modifier = Modifier.size(52.dp).background(AppSurface, RoundedCornerShape(6.dp)),
                contentScale = ContentScale.Crop
            )
        } else {
            Box(Modifier.size(34.dp).background(Color(0xFFEAF0FF), RoundedCornerShape(6.dp)), contentAlignment = Alignment.Center) {
                Icon(painterResource(Res.drawable.document), attachment.name, tint = AppPrimary, modifier = Modifier.size(20.dp))
            }
        }
        Spacer(Modifier.width(10.dp))
        Column(Modifier.weight(1f)) {
            Text(attachment.name, color = AppNavy, fontSize = 13.sp, fontWeight = FontWeight.Medium, maxLines = 1, overflow = TextOverflow.Ellipsis)
            Text("$kind  •  ${attachment.sizeLabel}", color = AppMuted, fontSize = 11.sp)
        }
        if (isDownloading) {
            CircularProgressIndicator(color = AppPrimary, strokeWidth = 2.dp, modifier = Modifier.size(20.dp))
        } else {
            Icon(
                painterResource(Res.drawable.download),
                "Download ${attachment.name}",
                tint = if (attachment.url.isNotBlank()) AppPrimary else AppMuted,
                modifier = Modifier.size(20.dp).then(if (attachment.url.isBlank()) Modifier else Modifier.clickable(onClick = onDownload))
            )
        }
    }
}

private fun formatSupportAttachmentSize(bytes: Long?): String = when {
    bytes == null || bytes <= 0L -> "File"
    bytes < 1024L -> "$bytes B"
    bytes < 1024L * 1024L -> "${bytes / 1024L} KB"
    else -> "${bytes / (1024L * 1024L)} MB"
}

private fun isSupportImageFile(fileName: String): Boolean =
    fileName.substringAfterLast('.', "").lowercase() in setOf("jpg", "jpeg", "png")

@Composable
private fun TicketDialogValue(label: String, value: String, modifier: Modifier) {
    Column(modifier, verticalArrangement = Arrangement.spacedBy(4.dp)) {
        Text(label, color = AppNavy, fontSize = AppDialogLabelSize, fontWeight = FontWeight.SemiBold)
        Text(value.ifBlank { "—" }, color = AppNavy, fontSize = AppDialogInputSize, fontWeight = FontWeight.Normal)
    }
}

private data class SuperAdminTicket(
    val id: String,
    val school: String,
    val role: String,
    val subject: String,
    val raisedOn: String,
    val status: String,
    val assignedTo: String,
    val conversation: List<Pair<String, String>>,
    val backendId: String = id
)

private val superAdminTickets = listOf(
    SuperAdminTicket("TKT-10001", "Greenfield Public School", "Parent", "Unable to view exam result", "05 Aug 2026", "Open", "Support Team", listOf("Anita Sharma" to "I am unable to open the exam result for my child. The page remains blank.")),
    SuperAdminTicket("TKT-10002", "Sunrise International School", "Teacher", "Attendance not updating", "05 Aug 2026", "In Progress", "Neha Kapoor", listOf("Vikram Rao" to "Attendance is not updating for my class.")),
    SuperAdminTicket("TKT-10003", "St. Mary's Academy", "School Admin", "Homework attachment not opening", "04 Aug 2026", "In Progress", "Rahul Mehta", listOf("Priya Nair" to "The homework attachment does not open for parents.")),
    SuperAdminTicket("TKT-10004", "Delhi Public School", "Parent", "Parent account login issue", "04 Aug 2026", "Open", "Support Team", listOf("Rohan Das" to "A parent is unable to sign in to the school portal.")),
    SuperAdminTicket("TKT-10005", "Greenfield Public School", "Teacher", "Notice not visible", "04 Aug 2026", "Resolved", "Neha Kapoor", listOf("Meera Shah" to "The latest notice is not visible to parents.")),
    SuperAdminTicket("TKT-10006", "Sunrise International School", "School Admin", "Unable to submit reply", "04 Aug 2026", "Closed", "Unassigned", listOf("Arjun Menon" to "The support reply cannot be submitted."))
)

@Composable
private fun LegacySuperAdminSupportQueueScreen(
    roleLabel: String,
    onChangeRole: () -> Unit,
    onLogout: () -> Unit
) {
    val viewModel = remember { SupportQueueViewModel() }
    val queueState by viewModel.uiState.collectAsState()
    var tickets by remember { mutableStateOf(emptyList<SuperAdminTicket>()) }
    LaunchedEffect(queueState.tickets) {
        tickets = queueState.tickets.map { ticket ->
            SuperAdminTicket(
                id = ticket.ticketId.ifBlank { ticket.id },
                school = ticket.schoolName,
                role = displaySupportRole(ticket.requesterRole),
                subject = ticket.subject,
                raisedOn = formatSupportDate(ticket.createdAt),
                status = displaySupportStatus(ticket.status),
                assignedTo = ticket.assignedToName,
                conversation = emptyList(),
                backendId = ticket.id
            )
        }
    }
    DisposableEffect(viewModel) { onDispose { viewModel.clear() } }
    var selectedTicket by remember { mutableStateOf<SuperAdminTicket?>(null) }
    var profileExpanded by remember { mutableStateOf(false) }
    var query by remember { mutableStateOf("") }
    var school by remember { mutableStateOf("All Schools") }
    var status by remember { mutableStateOf("All Statuses") }
    var timeRange by remember { mutableStateOf(queueState.periodRange) }
    val headerActions: @Composable RowScope.() -> Unit = {
        ShellTopRightActions(
            roleLabel = roleLabel,
            roleSubtitle = "Super Administrator",
            initials = shellAvatarInitials(roleLabel),
            expanded = profileExpanded,
            onExpandedChange = { profileExpanded = it },
            onChangeRole = onChangeRole,
            onLogout = onLogout
        )
    }

    Box(Modifier.fillMaxSize().background(AppBackground)) {
        AdminListPageScaffold(
            title = "Support Queue",
            subtitle = "Review and manage support tickets raised across schools.",
            backgroundColor = AppBackground,
            titleColor = AppNavy,
            subtitleColor = AppMuted,
            maxContentWidth = 1500.dp,
            headerActions = headerActions,
            summaryCards = {
                AdminListSummaryCard("Open", tickets.count { it.status == "Open" }.toString(), "Current page", painterResource(Res.drawable.document), AppPrimary, AppPrimarySoft, AppMuted, modifier = Modifier.weight(1f))
                AdminListSummaryCard("In Progress", tickets.count { it.status == "In Progress" }.toString(), "Current page", painterResource(Res.drawable.refresh_cw), AppWarning, AppWarningSoft, AppMuted, modifier = Modifier.weight(1f))
                AdminListSummaryCard("Resolved", tickets.count { it.status == "Resolved" }.toString(), "Current page", painterResource(Res.drawable.circle_check), AppSuccess, AppSuccessSoft, AppMuted, modifier = Modifier.weight(1f))
                AdminListSummaryCard("Total", queueState.totalCount.toString(), "All matching tickets", painterResource(Res.drawable.document), AppPrimary, AppPrimarySoft, AppMuted, modifier = Modifier.weight(1f))
            },
            toolbar = {
                SuperAdminSupportToolbar(
                    tickets = tickets,
                    query = query,
                    school = school,
                    status = status,
                    timeRange = timeRange,
                    onQueryChanged = { query = it; viewModel.searchChanged(it) },
                    onSchoolChanged = { school = it; viewModel.schoolChanged(it) },
                    onStatusChanged = { status = it; viewModel.statusChanged(it) },
                    onTimeRangeChanged = { timeRange = it; viewModel.periodChanged(it) },
                    onClearFilters = {
                        query = ""
                        school = "All Schools"
                        status = "All Statuses"
                        timeRange = "All Time"
                        viewModel.clearFilters()
                    }
                )
            },
            table = { modifier ->
                SuperAdminSupportTable(
                    modifier = modifier,
                    tickets = tickets,
                    isLoading = queueState.isLoading,
                    errorMessage = queueState.errorMessage,
                    pageIndex = queueState.pageIndex,
                    pageSize = queueState.pageSize,
                    totalCount = queueState.totalCount,
                    onPageChanged = viewModel::pageChanged,
                    onPageSizeChanged = viewModel::pageSizeChanged,
                    sortBy = queueState.sortBy,
                    sortAscending = queueState.sortAscending,
                    onSortChanged = viewModel::sortChanged,
                    onRetry = viewModel::retry,
                    onViewTicket = { selectedTicket = it }
                )
            },
            bottomAction = {}
        )
    }

    selectedTicket?.let { ticket ->
        SuperAdminTicketDialog(
            ticket = ticket,
            onDismiss = { selectedTicket = null },
            onReply = { reply ->
                tickets = tickets.map { current ->
                    if (current.id == ticket.id) current.copy(conversation = current.conversation + ("SuperAdmin" to reply), status = if (current.status == "Open") "In Progress" else current.status) else current
                }
                selectedTicket = null
            },
            onStatusChanged = { newStatus ->
                tickets = tickets.map { current -> if (current.id == ticket.id) current.copy(status = newStatus) else current }
                selectedTicket = tickets.first { it.id == ticket.id }
            },
            onAssigneeChanged = { assignee ->
                tickets = tickets.map { current -> if (current.id == ticket.id) current.copy(assignedTo = assignee) else current }
                selectedTicket = tickets.first { it.id == ticket.id }
            }
        )
    }
}

@Composable
private fun SuperAdminSupportToolbar(
    tickets: List<SuperAdminTicket>,
    query: String,
    school: String,
    status: String,
    timeRange: String,
    onQueryChanged: (String) -> Unit,
    onSchoolChanged: (String) -> Unit,
    onStatusChanged: (String) -> Unit,
    onTimeRangeChanged: (String) -> Unit,
    onClearFilters: () -> Unit
) {
    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(14.dp), verticalAlignment = Alignment.CenterVertically) {
        AdminListSearchField(query, onQueryChanged, "Search by Ticket ID or Subject", width = 360.dp, modifier = Modifier.weight(1.4f))
        SupportFilterDropdown(school, listOf("All Schools") + tickets.map { it.school }.distinct(), Modifier.weight(1f), onSchoolChanged)
        SupportFilterDropdown(status, listOf("All Statuses", "Open", "In Progress", "Resolved", "Closed"), Modifier.weight(1f), onStatusChanged)
        SupportFilterDropdown(timeRange, listOf("All Time", "Last 30 Days", "Last 90 Days"), Modifier.weight(1f), onTimeRangeChanged)
        AppOutlinedButton(
            onClick = onClearFilters,
            modifier = Modifier.width(104.dp).height(44.dp),
            contentPadding = PaddingValues(horizontal = 12.dp),
            colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary),
            shape = RoundedCornerShape(8.dp)
        ) {
            Icon(painterResource(Res.drawable.refresh_cw), contentDescription = null, modifier = Modifier.size(17.dp), tint = AppPrimary)
            Spacer(Modifier.width(6.dp))
            Text("Clear", color = AppPrimary)
        }
    }
}

@Composable
private fun SuperAdminSupportTable(
    modifier: Modifier,
    tickets: List<SuperAdminTicket>,
    isLoading: Boolean,
    errorMessage: String,
    pageIndex: Int,
    pageSize: Int,
    totalCount: Int,
    sortBy: String,
    sortAscending: Boolean,
    onSortChanged: (String, Boolean) -> Unit,
    onPageChanged: (Int) -> Unit,
    onPageSizeChanged: (Int) -> Unit,
    onRetry: () -> Unit,
    onViewTicket: (SuperAdminTicket) -> Unit
) {
    var rowsMenu by remember { mutableStateOf(false) }
    fun toggleSort(field: String) {
        onSortChanged(field, if (sortBy == field) !sortAscending else true)
    }
    val window = pageWindow(pageIndex, pageSize, totalCount)
    AdminListTableCard(
        modifier = modifier,
        minContentWidth = 1320.dp,
        header = {
            AdminListSortHeaderRow(
                listOf(
                    AdminListSortColumn("Ticket ID", 1.15f, sortBy == "ticket_id", sortAscending) { toggleSort("ticket_id") },
                    AdminListSortColumn("School Name", 1.55f, sortBy == "school_name", sortAscending) { toggleSort("school_name") },
                    AdminListSortColumn("Role", 1.15f, false, true) {},
                    AdminListSortColumn("Subject", 1.55f, sortBy == "subject", sortAscending) { toggleSort("subject") },
                    AdminListSortColumn("Raised On", 1f, sortBy == "created_at", sortAscending) { toggleSort("created_at") },
                    AdminListSortColumn("Status", 0.9f, sortBy == "status", sortAscending) { toggleSort("status") },
                    AdminListSortColumn("Assigned To", 1.15f, false, true) {}
                ),
                actionsLabel = "Actions",
                actionsWeight = 0.55f
            )
        },
        body = {
            if (isLoading) {
                AdminListTableShimmer(
                    columns = listOf(
                        AdminListHeaderColumn("Ticket ID", 1.15f),
                        AdminListHeaderColumn("School Name", 1.55f),
                        AdminListHeaderColumn("Role", 1.15f),
                        AdminListHeaderColumn("Subject", 1.55f),
                        AdminListHeaderColumn("Raised On", 1f),
                        AdminListHeaderColumn("Status", 0.9f),
                        AdminListHeaderColumn("Assigned To", 1.15f),
                        AdminListHeaderColumn("Actions", 0.55f)
                    ),
                    rowCount = pageSize.coerceAtLeast(5),
                    modifier = Modifier.fillMaxWidth(),
                    horizontalPadding = 24.dp
                )
            } else if (errorMessage.isNotBlank()) {
                Column(Modifier.fillMaxWidth().heightIn(min = 220.dp), horizontalAlignment = Alignment.CenterHorizontally, verticalArrangement = Arrangement.Center) {
                    AppDialogErrorMessage(errorMessage)
                    Text("Retry", color = AppPrimary, fontWeight = FontWeight.Bold, modifier = Modifier.clickable(onClick = onRetry))
                }
            } else if (tickets.isEmpty()) {
                Box(Modifier.fillMaxWidth().heightIn(min = 220.dp), contentAlignment = Alignment.Center) { AppText("No tickets found", color = AppNavy, fontWeight = FontWeight.Bold) }
            } else AdminListTableBody(items = tickets, key = { it.backendId.ifBlank { it.id } }, modifier = Modifier.fillMaxWidth()) { ticket ->
                Row(Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 15.dp), verticalAlignment = Alignment.CenterVertically) {
                    AdminListTableBodyText(ticket.id, Modifier.weight(1.15f), color = AppPrimary, fontWeight = FontWeight.Bold)
                    AdminListTableBodyText(ticket.school, Modifier.weight(1.55f))
                    AdminListTableBodyText(ticket.role, Modifier.weight(1.15f))
                    AdminListTableBodyText(ticket.subject, Modifier.weight(1.55f))
                    AdminListTableBodyText(ticket.raisedOn, Modifier.weight(1f))
                    Box(Modifier.weight(0.9f), contentAlignment = Alignment.CenterStart) { StatusChip(ticket.status) }
                    AdminListTableBodyText(ticket.assignedTo, Modifier.weight(1.15f))
                    Box(Modifier.weight(0.55f), contentAlignment = Alignment.CenterStart) {
                        IconButton(onClick = { onViewTicket(ticket) }, modifier = Modifier.size(32.dp)) {
                            Icon(painterResource(Res.drawable.eye), "View ${ticket.id}", tint = AppPrimary, modifier = Modifier.size(20.dp))
                        }
                    }
                }
            }
        },
        footer = { AdminListFooter(pageFooterText(window, "tickets"), window.pageIndex, window.pageCount, onPageChanged, pageSize, rowsMenu, { rowsMenu = !rowsMenu }, { rowsMenu = false }, onPageSizeChanged) }
    )
}

@Composable
private fun SuperAdminTicketDialog(
    ticket: SuperAdminTicket,
    onDismiss: () -> Unit,
    onReply: (String) -> Unit,
    onStatusChanged: (String) -> Unit,
    onAssigneeChanged: (String) -> Unit
) {
    var reply by remember(ticket.id, ticket.conversation) { mutableStateOf("") }
    AppDialogScaffold(onDismiss = onDismiss, size = AppDialogSize.Wide, dialogWidthOverride = 860.dp, maxDialogHeight = 820.dp) {
        AppDialogHeader(title = "View & Manage Ticket", subtitle = "Review ticket details and respond to the requester.", titleSuffix = ticket.id, titleSuffixSeparator = " ", titleSuffixFontSize = 16.sp, onClose = onDismiss, colors = AppDialogDefaultColors)
        AppDialogBody(
            horizontalPadding = 24.dp,
            verticalPadding = 18.dp,
            showVerticalScrollbar = true
        ) {
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(28.dp)) {
                Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(12.dp)) {
                    TicketDialogValue("Subject", ticket.subject, Modifier.fillMaxWidth())
                    TicketDialogValue("School Name", ticket.school, Modifier.fillMaxWidth())
                    TicketDialogValue("Raised By", ticket.conversation.firstOrNull()?.first ?: "User", Modifier.fillMaxWidth())
                    TicketDialogValue("Role", ticket.role, Modifier.fillMaxWidth())
                    TicketDialogValue("Raised On", ticket.raisedOn, Modifier.fillMaxWidth())
                }
                Column(Modifier.weight(.9f), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                    AppDialogSectionLabel("Current Status", colors = AppDialogDefaultColors, fontSize = 13.sp)
                    SupportFilterDropdown(ticket.status, listOf("Open", "In Progress", "Resolved", "Closed"), Modifier.fillMaxWidth(), onStatusChanged)
                    AppDialogSectionLabel("Assigned To", colors = AppDialogDefaultColors, fontSize = 13.sp)
                    SupportFilterDropdown(ticket.assignedTo, listOf("Support Team", "Neha Kapoor", "Rahul Mehta", "Unassigned"), Modifier.fillMaxWidth(), onAssigneeChanged)
                }
            }
            AppDialogDivider()
            AppDialogSectionLabel("Conversation History", colors = AppDialogDefaultColors, fontSize = 16.sp)
            ticket.conversation.forEach { (sender, message) ->
                Surface(Modifier.fillMaxWidth(), color = Color.White, shape = RoundedCornerShape(8.dp), border = BorderStroke(1.dp, AppBorder)) {
                    Column(Modifier.padding(14.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                        Text(sender, color = AppNavy, fontSize = AppDialogInputSize, fontWeight = FontWeight.SemiBold)
                        Text(message, color = AppNavy, fontSize = AppDialogInputSize, fontWeight = FontWeight.Normal)
                    }
                }
            }
            AppDialogFieldColumn("Reply", colors = AppDialogDefaultColors) {
                AppDialogTextField(value = reply, onValueChange = { reply = it }, placeholder = "Type your reply", colors = AppDialogDefaultColors, singleLine = false, fieldHeight = 96.dp, maxLength = 2000)
            }
            AppOutlinedButton(onClick = {}, modifier = Modifier.height(40.dp), colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary), border = BorderStroke(1.dp, AppBorder), shape = RoundedCornerShape(8.dp), contentPadding = PaddingValues(horizontal = 14.dp)) {
                Icon(painterResource(Res.drawable.document), null, modifier = Modifier.size(18.dp)); Spacer(Modifier.width(8.dp)); Text("Add Attachment", fontSize = 14.sp, fontWeight = FontWeight.Medium)
            }
        }
        AppDialogDivider()
        AppDialogFooter(actions = listOf(AppDialogFooterAction("Close", onDismiss, AppDialogActionStyle.Secondary, width = 108.dp), AppDialogFooterAction("Send Reply", { onReply(reply.trim()) }, AppDialogActionStyle.Primary, enabled = reply.isNotBlank(), width = 140.dp)), colors = AppDialogDefaultColors, equalWeightButtons = false)
    }
}
